import React, { useEffect } from 'react';
import useReactRouter from 'use-react-router';
import { stringify } from 'querystring';

import CommonContainer from '../../containers/Common';

export default ((props) => {

  const commonContainer = CommonContainer.useContainer();
  const { history, location } = useReactRouter();

  var token = localStorage.getItem('token');

  if (!token) {
    var queryString = stringify({ redirect: `${location.pathname}${location.search}` });
    history.push(`/users/login?${queryString}`);
    return <></>;
  }

  useEffect(() => {
    (async () => {
      await commonContainer.loadMe();
    })();
  }, []);

  return <>{props.children}</>
}) as React.FC;
